import LandingPage from "@/components/pages/homepage/LandingPage";

let routes = [
  {
    component: LandingPage,
    path: "/lp/business-card-portal",
    meta: { title: "Business Card Printing Portal | Brandly" },
    props: {
      headline:
        "Get the #1 business card printing portal, <span>for free</span>.",
      subtitle:
        "Simplify the way your company prints business cards dramatically with an all-in-one ordering portal.",
      description:
        "Open a free business card portal and print high-quality business cards for your entire company in minutes.",
      keywords: "Business Card Portal"
    }
  },
  {
    component: LandingPage,
    path: "/lp/corporate-business-cards",
    meta: { title: "Corporate Business Card Printing | Brandly" },
    props: {
      headline: "The #1 business card printing solution for corporations.",
      subtitle:
        "Simplify the way your company prints business cards dramatically with an all-in-one ordering portal.",
      description:
        "Get a printing storefront just for your company and order top-quality business cards for your entire company in minutes",
      keywords: "Corporate Business Cards"
    }
  },
  {
    component: LandingPage,
    path: "/lp/bulk-business-cards",
    meta: { title: "Bulk Business Card Printing | Brandly" },
    props: {
      headline: "Print business cards in bulk at low prices",
      subtitle:
        "Simplify the way your company prints business cards dramatically with an all-in-one ordering portal.",
      description:
        "Get more for less by printing business cards in bulk. Take advantage of our discounted printing and free shipping on every order.",
      keywords: "Bulk Business Cards"
    }
  }
];

export default routes;



// WEBPACK FOOTER //
// ./src/router/landingpages.js